<template>
  <div class="block">
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <SimpleSelect
        class="mr-5"
        buttonPlaceholder="所有選項"
        buttonWidth="150px"
        modalWidth="150px"
        :options="options.tableColumn"
        :selectedValue.sync="tableColumnFilter"
      ></SimpleSelect>
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="textFilter"
        />
      </div>
      <button class="btn btn-primary w-88px">搜尋</button>
      <OptionsFilter></OptionsFilter>
      <!-- <button class="btn w-104px ml-5">
        <v-icon class="mr-2">filter_list</v-icon>
        <span>已篩選</span>
      </button> -->
    </div>

    <!-- table -->
    <div class="table">
      <div class="table-head">
        <!-- column head -->
        <div
          v-if="lengthOfisCheckedList == 0"
          class="form-item d-flex px-5 h-60px align-center"
        >
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="col-date">面試日期</h5>
          <h5 class="col-phrase">面試階段</h5>
          <h5 class="col-unit">用人單位</h5>
          <h5 class="col-position">應徵職務</h5>
          <h5 class="col-superviser">面試主管</h5>
          <h5 class="col-result">面試結果</h5>
          <h5 class="col-name">求職者姓名</h5>
          <h5 class="col-resource">履歷來源</h5>
          <h5 class="col-icon ml-auto">履歷</h5>
          <h5 class="col-icon">備註</h5>
          <h5 class="col-edit">編輯</h5>
          <h5 class="col-delete">刪除</h5>
        </div>
        <!-- column action -->
        <div v-else class="form-item d-flex align-center px-5 h-60px">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <button
            class="btn btn-danger mr-10px"
            @click="deleteItems(selectedItems)"
          >
            <v-icon color="white" class="mr-2">delete</v-icon>
            <span>刪除</span>
          </button>
          <button class="btn mr-10px">寄送資訊</button>
          <TableControlAdmissionStatus
            @set-admission-status="setAdmissionStatusAll"
          ></TableControlAdmissionStatus>
        </div>
      </div>
      <div class="table-body">
        <div
          class="form-item d-flex h-60px align-center"
          v-for="item in filterNumPerPageTableList"
          :class="{ 'brand-100': selectedItems.includes(item.id) }"
          :key="item.id"
        >
          <div class="h5 col-checkbox">
            <v-checkbox
              v-model="selectedItems"
              :value="item.id"
              :key="`checkbox-${item.id}`"
            ></v-checkbox>
          </div>
          <div class="h5 col-date">
            <span class="mr-10px">{{ objToDate(item.interviewTime) }}</span>
            <span>{{ objToTime(item.interviewTime) }}</span>
          </div>
          <div class="h5 col-phrase">{{ item.phrase }}</div>
          <div class="h5 col-unit">{{ item.unit }}</div>
          <div class="h5 col-position">{{ item.position }}</div>
          <div class="h5 col-superviser tooltip-wrap">
            <div>
              {{
                item.supervisors.length > 1
                  ? `${item.supervisors[0]}...`
                  : item.supervisors[0]
              }}
            </div>
            <div class="tooltip">
              <span
                v-for="(supervisor, i) in item.supervisors"
                :key="supervisor"
              >
                {{ i >= 1 ? ', ' : '' }}
                {{ supervisor }}
              </span>
            </div>
          </div>
          <div class="h5 col-result tooltip-wrap">
            <v-icon v-if="item.result === '錄取'" color="success-500"
              >check_circle</v-icon
            >
            <v-icon v-if="item.result === '未錄取'" color="danger-500"
              >cancel</v-icon
            >
            <v-icon v-if="item.result === '黑名單'" color="gray-900"
              >block</v-icon
            >
            <div class="tooltip">{{ item.result }}</div>
          </div>
          <div class="h5 col-name">
            <div>{{ item.name }}</div>
            <div class="h6 ink-02-medium--text">{{ item.phone }}</div>
          </div>
          <div class="h5 col-resume">
            <div>{{ item.resumeResource }}</div>
            <div class="h6 ink-02-medium--text">
              {{ item.resumeResourceCode }}
            </div>
          </div>
          <div class="h5 col-icon ml-auto">
            <button class="btn square">
              <v-icon>link</v-icon>
            </button>
          </div>
          <div class="h5 col-icon">
            <ResumeRemarks
              :parentRemarks="item.remarks"
              @save-remarks="(payload) => (item.remarks = payload)"
            ></ResumeRemarks>
          </div>
          <div class="h5 col-edit ">
            <button class="btn square" @click="editItem">
              <v-icon>edit</v-icon>
            </button>
          </div>
          <div class="h5 col-delete">
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </div>
        </div>
      </div>
    </div>

    <!-- table footer -->
    <div class="d-flex justify-end align-center h5" style="padding: 26px 20px;">
      <!-- item per page -->
      <div class="mr-10px d-flex align-center">
        <span class="mr-10px">單頁顯示筆數</span>
        <TableNumPerPage
          v-model="numberOfItemsPerPage"
          @input="currentPage = 1"
        ></TableNumPerPage>
      </div>
      <!-- item total -->
      <div class="mr-10px">
        <span style="margin-right: 2px">{{ displayPageToPage() }}</span>
        <span>共 {{ filterTableList.length }}筆</span>
      </div>
      <!-- pre and next -->
      <div>
        <button class="btn square w-32px h-32px mr-4" @click="lastPage">
          <v-icon>navigate_before</v-icon>
        </button>
        <button class="btn square w-32px h-32px" @click="nextPage">
          <v-icon>navigate_next</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from '@/components/Selection/SimpleSelect.vue';
import TableControlAdmissionStatus from '@/views/J__HR/c/TableControlAdmissionStatus.vue';
import OptionsFilter from '@/views/J__HR/c/OptionsFilter.vue';
import ResumeRemarks from '@/views/J__HR/c/ResumeRemarks.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import TableNumPerPage from '@/components/TableNumPerPage.vue';

export default {
  components: {
    SimpleSelect,
    TableControlAdmissionStatus,
    OptionsFilter,
    ResumeRemarks,
    deleteDialog,
    TableNumPerPage,
  },
  data: () => ({
    // filter
    textFilter: '',
    tableColumnFilter: '',
    checkAllStatus: false,
    // selectedItems
    selectedItems: [],
    // table lsit
    tableList: [
      {
        id: '001',
        interviewTime: {
          year: '2020',
          month: '8',
          date: '8',
          hour: '15',
          minute: '0',
        },
        phrase: '初試-視訊',
        unit: '人資部',
        position: '人力招募管理師',
        supervisors: ['李英豪', '羅嘉仁'],
        result: '錄取',
        name: '王名名',
        phone: '0900-000-000',
        resumeResource: '104',
        resumeResourceCode: '1234567890',
        remarks: '',
      },
      {
        id: '002',
        interviewTime: {
          year: '2020',
          month: '8',
          date: '8',
          hour: '15',
          minute: '0',
        },
        phrase: '初試-視訊',
        unit: '人資部',
        position: '人力招募管理師',
        supervisors: ['李英豪', '羅嘉仁', '大中天'],
        result: '未錄取',
        name: '陳皓皓',
        phone: '0900-000-000',
        resumeResource: '104',
        resumeResourceCode: '1234567890',
        remarks: '',
      },
      {
        id: '003',
        interviewTime: {
          year: '2020',
          month: '8',
          date: '8',
          hour: '15',
          minute: '0',
        },
        phrase: '初試-視訊',
        unit: '人資部',
        position: '人力招募管理師',
        supervisors: ['李英豪', '羅嘉仁', '大中天'],
        result: '黑名單',
        name: '張三三',
        phone: '0900-000-000',
        resumeResource: '104',
        resumeResourceCode: '1234567890',
        remarks: '',
      },
    ],
    options: {
      tableColumn: [
        '所有選項',
        '求職者姓名',
        '用人單位',
        '應徵職務',
        '面試主管',
        '招募窗口',
        '履歷來源',
        '面試結果',
      ],
      admissionStatus: ['錄取', '未錄取', '黑名單'],
    },
    // footer
    numberOfItemsPerPage: '10',
    currentPage: 1,
  }),
  computed: {
    filterTableList() {
      const vm = this;

      return (
        this.tableList
          // textFilter
          .filter((item) => item.name.toLowerCase().includes(vm.textFilter))
      );
    },
    filterNumPerPageTableList() {
      const vm = this;
      return this.filterTableList.filter((item, i) => {
        if (vm.numberOfItemsPerPage === 'All') return true;
        return (
          i <= Number(vm.numberOfItemsPerPage) * vm.currentPage - 1 &&
          i >= Number(vm.numberOfItemsPerPage) * (vm.currentPage - 1)
        );
      });
    },
    lengthOfisCheckedList() {
      return this.selectedItems.length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.filterNumPerPageTableList.length
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.filterNumPerPageTableList.length) {
        this.checkAllStatus = false;
      } else if (newValue === 0) {
        this.checkAllStatus = false;
      } else if (newValue === this.filterNumPerPageTableList.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    test(item) {
      console.log('filter item click', item);
    },
    setAdmissionStatus(itemId, status) {
      this.tableList.find((item) => item.id === itemId).result = status;
    },
    setAdmissionStatusAll(status) {
      this.selectedItems.forEach((itemId) => {
        this.setAdmissionStatus(itemId, status);
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        const allItemsInPage = this.filterNumPerPageTableList.map(
          (item) => item.id,
        );
        this.$set(this, 'selectedItems', allItemsInPage);
      } else {
        this.$set(this, 'selectedItems', []);
      }
    },
    editItem() {
      this.$router.push('/human-resource/resume-edit');
    },
    deleteItem(itemId) {
      const index = this.tableList.findIndex(
        (listItem) => listItem.id === itemId,
      );
      this.tableList.splice(index, 1);

      const selectedIndex = this.selectedItems.findIndex((listItem) => {
        console.log(listItem, itemId);
        return listItem === itemId;
      });
      console.log('selectedIndex', selectedIndex);
      if (selectedIndex >= 0) {
        this.selectedItems.splice(selectedIndex, 1);
      }
    },
    deleteItems(itemIds) {
      console.log(itemIds);
      [...itemIds].forEach((itemId) => {
        this.deleteItem(itemId);
      });
    },
    lastPage() {
      if (this.currentPage === 1) {
        return;
      }
      this.currentPage -= 1;
    },
    nextPage() {
      if (this.numberOfItemsPerPage === 'All') return;
      if (
        this.currentPage * Number(this.numberOfItemsPerPage) >
        this.filterTableList.length
      ) {
        return;
      }
      this.currentPage += 1;
    },
    displayPageToPage() {
      let left;
      let right;

      const filterLength = this.filterTableList.length;
      const perPageLength = Number(this.numberOfItemsPerPage);

      if (this.numberOfItemsPerPage === 'All') {
        left = 1;
        right = filterLength;
      } else {
        left = 1 + perPageLength * (this.currentPage - 1);
        right = perPageLength * this.currentPage;
        if (perPageLength * this.currentPage > filterLength) {
          right = filterLength;
        }
      }

      return `${left}-${right}`;
    },
    objToDate(obj) {
      const year = String(obj.year);
      const month = String(obj.month).padStart(2, '0');
      const date = String(obj.date).padStart(2, '0');
      return `${year}.${month}.${date}`;
    },
    objToTime(obj) {
      const hour = String(obj.hour).padStart(2, '0');
      const minute = String(obj.minute).padStart(2, 0);
      return `${hour}:${minute}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-date {
    width: 120px;
    margin-right: 18px;
  }
  .col-phrase {
    width: 65px;
    margin-right: 18px;
  }
  .col-unit {
    width: 58px;
    margin-right: 18px;
  }
  .col-position {
    width: 98px;
    margin-right: 18px;
  }
  .col-superviser {
    width: 58px;
    margin-right: 18px;
  }
  .col-result {
    width: 58px;
    margin-right: 18px;
    text-align: center;
  }
  .col-name {
    width: 77px;
    margin-right: 18px;
  }
  .col-resource {
    width: 67px;
  }
  .tooltip-wrap {
    position: relative;
    .tooltip {
      display: none;
    }
  }
  .tooltip-wrap:hover {
    .tooltip {
      display: block;
      position: absolute;
      top: -4px;
      left: 50%;
      transform: translateX(-50%) translateY(-100%);
      height: 28px; // triangle 4px
      max-width: 500px;
      padding: 6px 8px;
      color: #fff;
      background-color: #353e4d;
      border-radius: 4px;
      font-size: 12px;
      line-height: 16px;
      white-space: nowrap;
    }
  }
}
</style>
